import { render } from "./InformingSection.vue?vue&type=template&id=f313ce98&scoped=true"
import script from "./InformingSection.vue?vue&type=script&lang=js"
export * from "./InformingSection.vue?vue&type=script&lang=js"

import "./InformingSection.vue?vue&type=style&index=0&id=f313ce98&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/Mosolysziget/Mosolysziget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f313ce98"]])

export default __exports__